import React, { useEffect } from 'react';
import axios from 'src/utils/axios';
import { Card, Container, Box, Backdrop, CircularProgress, Grid, Divider, CardContent, CardHeader, IconButton, Autocomplete, TextField, Button, Stack, Checkbox, MenuItem, Alert, Snackbar } from "@mui/material";
import { makeStyles } from '@material-ui/styles';
import { DataGrid, GridToolbarContainer, GridToolbarExport, trTR, } from '@mui/x-data-grid';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import SearchIcon from '@mui/icons-material/Search';
import Page from 'src/components/Page';
import AlertComponent from 'src/components/Alert';
import PrintIcon from '@mui/icons-material/Print';
import ExcelFileCreator from 'src/components/ExcelFileCreator'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  backdrop: {
    zIndex: 2000,
    color: '#fff'
  }
}));

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const smsStatusOptions = [
  { label: 'Aktif', value: 1 },
  { label: 'Pasif', value: 0 },
]

function SmsTemplateTrackingReport({ onClick }) {

  const classes = useStyles();
  const [smsGeneralData, setSmsGeneralData] = React.useState([]);
  const [loadingx, setLoadingx] = React.useState(false);
  const [smsSablonBasliklar, setSmsSablonBasliklar] = React.useState([]);
  const [selectedSmsSablonBasliklar, setSelectedSmsSablonBasliklar] = React.useState([]);
  const [selectedSmsAktifPasif, setSelectedSmsAktifPasif] = React.useState([]);
  const [selectedDurum, setSelectedDurum] = React.useState(null);
  const [Warning, setWarning] = React.useState(false);
  const [WarningType, setWarningType] = React.useState('default');
  const [responseMessage, setresponseMessage] = React.useState("");
  const [smsDurumlar, setSmsDurumlar] = React.useState([]);




  const columns = [
    {
      field: 'ACIKLAMA',
      headerName: 'Sms Şablon Başlık',
      width: 300,
    },
    {
      field: 'SABLON',
      headerName: 'Sms Şablon',
      width: 500,
    },
    {
      field: 'DURUM',
      headerName: 'Durum',
      width: 150,
    },
    {
      field: 'SABLON_KOSULLAR',
      headerName: 'Şablon Koşulları',
      width: 500,
    },
    {
      field: 'AKTIF',
      headerName: 'AKTIF',
      width: 100,
      renderCell: (cellValues) => {
        const isActive = cellValues?.row?.AKTIF;
        return (
          <Box sx={{ justifyContent: 'center', "& > :not(style)": { m: 1 } }} >
            <span>{isActive == 1 ? "Evet" : "Hayır"}</span>
          </Box>
        );
      }
    },
    {
      field: 'YENI_PROJEYE_TASINDI_MI',
      headerName: 'Yeni Projeye Taşındı Mı',
      width: 100,
      renderCell: (cellValues) => {
        const isActive = cellValues.row.YENI_PROJEYE_TASINDI_MI == 1;
        return (
          <Box sx={{ justifyContent: 'center', "& > :not(style)": { m: 1 } }} >
            <span>{isActive ? "Evet" : "Hayır"}</span>
          </Box>
        );
      }
    },
  ];

  function QuickSearchToolbar(props) {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <Grid container spacing={2} >
          <Grid item xs={4} md={4}>
            <GridToolbarContainer >
              <GridToolbarExport
                sx={{ color: '#FF9800' }}
                csvOptions={{
                  utf8WithBom: true,
                }} />
            </GridToolbarContainer>
          </Grid>

        </Grid>
      </Box>
    );
  }



  useEffect(() => {
    getSmsGonderilenSmsler();
    getSmsSablonBasliklar();
    getSmsDurumlar();
    GetSmsSablonTakipRaporu();
  }, []);

  const getSmsDurumlar = () => {
    axios.get("/GetSmsDurumlar").then((response) => {
      setSmsDurumlar(response.data);
    })
  }

  const GetSmsSablonTakipRaporu = () => {
    axios.get("/GetSmsSablonTakipRaporu").then((response) => {
      setSmsGeneralData(response.data);
    })
  }

  const getSmsGonderilenSmsler = () => {
    setLoadingx(true)
    axios.get("/GetSmsGonderilenSmsler").then((response) => {
      var successData = [];
      var errorData = [];
      if (response.data.length > 0) {
        response.data.map((i) => {
          if (i.DURUM === 3) {
            successData.push(i);//Gönderilen smsler
          }
          else {
            errorData.push(i);//Gönderilemeyen smsler
          }
        });
        setSmsGeneralData(response.data);
        GrafikDataDoldur(successData);
        setLoadingx(false);
      }
    })
    setLoadingx(false)
  }

  const getSmsSablonBasliklar = () => {
    setLoadingx(true)
    axios.get("/GetSmsRaporSablonBasliklar").then((response) => {
      setSmsSablonBasliklar(response.data)
      setLoadingx(false);
    })
  }

  function SmsSonuclariniFiltreliAra() {

    if ((!selectedSmsAktifPasif || (Object.entries(selectedSmsAktifPasif).length === 0)) || selectedSmsSablonBasliklar.length <= 0 || (!selectedDurum || (Object.entries(selectedDurum)?.length === 0))) {
      setresponseMessage('Lütfen kutucukları boş bırakmayınız!...');
      setWarning(true);
      setWarningType("error");
      return;
    }
    var SablonBasliklariList = [];
    selectedSmsSablonBasliklar.map((i) => {
      SablonBasliklariList.push(i.ID);
    })

    const data = {

      SmsRaporSablonBasliklar: SablonBasliklariList.toString(),
      SmsAktif: selectedSmsAktifPasif.value,
      FisDurum: selectedDurum.DURUM
    }


    setLoadingx(true);
    axios.get(`SmsGonderimSablonTakipRaporuAra/${data.SmsRaporSablonBasliklar}/${data.SmsAktif}/${data.FisDurum}`)
      .then((response) => {
        if (response.data.length > 0) {
          setSmsGeneralData(response.data);
          setLoadingx(false);
        } else {
          setSmsGeneralData([]);
        }
      })
    setLoadingx(false);
  }

  const WarningClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setWarning(false);
  };

  const handleExportClick = (buttonType) => {
    var exportData = [];
    if (buttonType === 1) {
      smsGeneralData.map((item) => {
        exportData.push({
          'Sms Sablon Baslık': item.ACIKLAMA,
          'Sms Sablon': item.SABLON,
          'Durum': item.DURUM,
          'Sablon Kosulları': item.SABLON_KOSULLAR,
          'Aktif': item.AKTIF == 1 ? 'Evet' : 'Hayır',
          'Yeni Projeye Tasındı Mı': item.YENI_PROJEYE_TASINDI_MI
        })
      })
      ExcelFileCreator(exportData, `Sms Şablon Takip Raporu`);
    }
  };


  return (
    <Page>
      <Backdrop className={classes.backdrop} open={loadingx}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Warning}
        autoHideDuration={10000}
        onClose={WarningClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <AlertComponent onClose={WarningClose} variant={WarningType} message={responseMessage}></AlertComponent>
      </Snackbar>
      <Card>
        <CardHeader title="Sms Şablon Takip Raporu"
          action={
            <IconButton onClick={onClick} style={{ color: 'orange' }}>
              <ArrowBackIcon />
            </IconButton>
          } />
        <Divider />
        <Container maxWidth="xl">
          <CardContent>
            <Grid container spacing={2} style={{ marginBottom: '0.1rem' }}>
              <Grid item xs={12} sm={6} lg={3}>
                <Autocomplete
                  multiple
                  size="small"
                  id="multiple-limit-tags"
                  fullWidth
                  limitTags={1}
                  disableCloseOnSelect
                  value={selectedSmsSablonBasliklar}
                  options={smsSablonBasliklar}
                  getOptionLabel={option => (option.SABLON ? option.SABLON : '')}
                  onChange={(event, newValue) => {
                    setSelectedSmsSablonBasliklar(newValue);
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.SABLON}
                    </li>
                  )}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Şablon Başlıkları"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={3}>
                <Autocomplete
                  disablePortal
                  size="small"
                  fullWidth
                  value={selectedDurum}
                  options={smsDurumlar}
                  getOptionLabel={(val) => val.ACIKLAMA}
                  renderInput={(params) => <TextField {...params} label="Fiş Durumları" variant="outlined" />}
                  onChange={(event, newValue) => { setSelectedDurum(newValue) }}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={2}>
                <Autocomplete
                  size="small"
                  id="multiple-limit-tags"
                  fullWidth
                  value={selectedSmsAktifPasif}
                  options={smsStatusOptions}
                  getOptionLabel={option => (option.label ? option.label : '')}
                  onChange={(event, newValue) => {
                    setSelectedSmsAktifPasif(newValue);
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Sms Aktif/Pasif"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={2}>
                <Button
                  className={classes.action}
                  variant="contained"
                  color="primary"
                  fullWidth
                  size='medium'
                  onClick={() => { SmsSonuclariniFiltreliAra(); }}
                >
                  ARA
                  <SearchIcon style={{ marginLeft: '5px' }} />
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} lg={2}>
                <Button
                  className={classes.action}
                  variant="contained"
                  color="primary"
                  fullWidth
                  size='medium'
                  onClick={() => {
                    handleExportClick(1);
                  }}
                >
                  YAZDIR
                  <PrintIcon style={{ marginLeft: '5px' }} />
                </Button>
              </Grid>
              <Divider />
              <Box sx={{ height: 600, width: '100%', marginTop: 1 }}>
                <DataGrid
                  rows={smsGeneralData}
                  columns={columns}
                  getRowId={(row) =>
                    row.MESAJ_SABLON_ID
                  }
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 100,
                      },
                    },
                  }}
                  components={{ Toolbar: QuickSearchToolbar }}
                  localeText={trTR.components.MuiDataGrid.defaultProps.localeText}
                  pageSizeOptions={[100]}
                />
              </Box>
            </Grid>
          </CardContent>
        </Container>
      </Card>
    </Page>
  );
}

export default SmsTemplateTrackingReport;